export default __webpack_public_path__ + "static/media/eFacil-01.1c7b8cb5.png";